import React, {useState, useEffect} from 'react';
import {Table, Input, List, Button, Pagination, Radio, Divider} from 'antd';
import http from 'libs/http';
import styles from './layout.module.less'

import store from "./store";
import projectStore from '../project/store'
import {observer} from 'mobx-react';
import lodash from "lodash";
import SearchForm,{SearchFormItem} from "../../../components/SearchForm";

import {InfoCircleOutlined,PaperClipOutlined} from '@ant-design/icons';

// the hook
import { useTranslation } from 'react-i18next';

export default observer(function () {
  const {t, i18n} = useTranslation()
  const [activeKey, setActiveKey] = useState('all')
  const [activeId, setActiveId] = useState();
  const [downloadLoading, setDownloadLoading] = useState();


  const columns = [
    // {
    //   title: '',
    //   dataIndex: 'type',
    //   key: 'type',
    //   className: 'pl0',
    //   width: 35,
    //   fixed: true,
    //   render: (val,info) => <div className={[styles.badge,i18n.language==='en'?styles.autoWidth:''].join(' ')}>
    //    {t(info.type_alias.charAt(0)==='销'?'购':info.type_alias.charAt(0))}
    //   </div>,
    // },
    {
      title: t('品牌'),
      dataIndex: 'brand',
      align: 'left',
      fixed: true,
      width: 220,
      render:(value,info)=>{
        return (<><span className={[styles.badge,!info?.catalogName?.includes('销') ? styles.badgeGhost : '',i18n.language==='en'?styles.autoWidth:''].join(' ')}>
          {t(info?.catalogName?.includes('销')?'购':info?.catalogName?.charAt(0))}
        </span>
        {value}</>)
      }
    },
    {
      title: t('产品品名'),
      dataIndex: 'name',
      align: 'center',
      fixed: true,
      width: 220,
    },
    {
      title: t('货号'),
      dataIndex: 'factoryCode',
      align: 'center',
      fixed: true,
      width: 150,
    },
    {
      title: t('规格'),
      dataIndex: 'formats',
      align: 'center',
      fixed: true,
      width: 150,
    },
    {
      title: t('单价'),
      dataIndex: 'price',
      align: 'center',
      width: 80,
      fixed: true,
      render: (val, record, index) => <div>{val ? val + (record.type * 1 === 2 ? t('元/月') : t('元')) : '-'}</div>,
    },
    {
      title: t('租期'),
      dataIndex: 'duration',
      width: 80,
      align: 'center',
      fixed: true,
      render: val => <div>{val ? val + t('月') : '-'}</div>,
    },
    {
      title: t('数量'),
      dataIndex: 'number',
      width: 80,
      align: 'center',
      fixed: true,
    },
    {
      title: t('合计'),
      dataIndex: 'totalPrice',
      align: 'center',
      width: 80,
      fixed: true,
      render: (val, record, index) => <div>{val ? val + t('元') : '-'}</div>,
    },
    {
      title: t('购物车备注'),
      dataIndex: 'cartRemarks',
      width: 120,
      align: 'center',
      fixed: true,
      render: val => <div>{val}</div>,
    },
    // {
    //   title: t('项目编号'),
    //   dataIndex: 'extra_sn',
    //   align: 'center',
    //   fixed: true,
    //   render:  (val, record, index) => {
    //     let project=projectStore.records.filter(v=>v.id===val*1)
    //     let txt='-'
    //     if(project.length){
    //       txt=project[0]['sn']
    //     }
    //     return <div>{txt}</div>
    //   },
    // },
    {
      title: t('预计到货'),
      dataIndex: 'period',
      width: 100,
      align: 'center',
      fixed: true,
      render: val => <div>{val}</div>,
    },
    // {
    //   title: t('状态'),
    //   dataIndex: 'statusName',
    //   width: 80,
    //   align: 'center',
    //   fixed: true,
    //   render: (val, record) => record['tag_alias'] ? (
    //     <Tooltip title={t(record['tag_alias'])} color='red' key={record['id']}>
    //       <span style={{color: 'red'}}>{t(val)} </span>
    //       <InfoCircleOutlined style={{color: 'red'}}/>
    //     </Tooltip>
    //   ) : t(val)
    // },
  ]

  useEffect(() => {
    // setLoading(true)
    resetSearch();
    // let status = activeKey === 'all' ? null : activeKey;
    // store.fetchRecords(status);

    // projectStore.fetchRecords();
  }, [])

  const makeRowClassName = (record, index) => {
    return record.disabled ? styles.disabled : ''
  }

  // const handleTabChange = (key) => {
  //   console.log(key,'key');
  //   setActiveKey(key)
  //   store.fetchRecords();
  // }

  function handleTabChange(e) {
    setActiveKey(e.target.value);
    store.page = 1;
    store.pageSize = localStorage.getItem('purchasePageSize') || 10;
    store.pageTotal = 0;
    let status = e.target.value === 'all' ? null : e.target.value
    store.fetchRecords(status);
  }

  const onSearch = (values) => {
    store.spp=values;
    store.page = 1;
    store.pageSize = localStorage.getItem('purchasePageSize') || 10;
    store.pageTotal = 0;
    let status = activeKey === 'all' ? null : activeKey
    store.fetchRecords(status);
  }

  const resetSearch = ()=>{
    store.page = 1;
    store.pageSize = localStorage.getItem('purchasePageSize') || 10;
    store.pageTotal = 0;
    store.spp = {};
    setActiveKey('all');
    store.fetchRecords(null);
  }

    //下载附件
    const downloadFile = (item)=>{
      setActiveId(item.id);
      setDownloadLoading(true);
      http.post('/javaApi/oss/getFileUrl',{filePath:item.attachmentPath}).then((res)=>{
        window.open(res.data.result)
      }).finally(()=>{
        setDownloadLoading(false);
      })
    }

  return (
    <React.Fragment>
      <div className={[styles.cart, 'rest-nav1', i18n.language === 'en' ? 'rest-nav1-en' : ''].join(" ")}>

        <div className={styles.listTitle}>
          {/* <span style={{paddingLeft: '15px'}}>{t('订单状态：')}</span> */}
          <Radio.Group value={activeKey} onChange={handleTabChange}>
              <Radio.Button value='all'>全部求购单</Radio.Button>
              <Divider type="vertical" />
              <Radio.Button value="0">待报价</Radio.Button>
              <Divider type="vertical" />
              <Radio.Button value="10">已报价</Radio.Button>
              <Divider type="vertical" />
              <Radio.Button value="11">已关闭</Radio.Button>
          </Radio.Group>
        </div>

        <SearchForm onFinish={onSearch} onReset={resetSearch}>
          <SearchFormItem title={t('产品名称')} name='productName' span={8}>
            <Input autoComplete="off" placeholder={t("请输入")} allowClear/>
          </SearchFormItem>
          <SearchFormItem title={t('求购编号')} name='sn' span={8}>
            <Input autoComplete="off" placeholder={t("请输入")} allowClear/>
          </SearchFormItem>
          {/* <SearchFormItem title={t('项目编号')} name='extraSn' span={8}>
            <Input autoComplete="off" placeholder={t("请输入")} allowClear/>
          </SearchFormItem> */}
          {/* <SearchFormItem title={t('中心号')} name='center_sn' span={8}>
            <Input autoComplete="off" placeholder={t("请输入")} allowClear/>
          </SearchFormItem> */}
          <SearchFormItem title={t('货号')} name='factoryCode' span={8}>
            <Input autoComplete="off" placeholder={t("请输入")} allowClear/>
          </SearchFormItem>
          <SearchFormItem title={t('品牌')} name='brand' span={8}>
            <Input autoComplete="off" placeholder={t("请输入")} allowClear/>
          </SearchFormItem>
        </SearchForm>

        <div className="mainBox">

          <List
              header=''
              footer=''
              dataSource={store.records}
              split={false}
              pagination={false}
              loading={store.isFetching}
              renderItem={(item, index) => (
                <List.Item>

                  <div style={{width: '100%'}}>
                    <div className={styles.innerTitle}>
                      <div className={styles.t1}>{t('求购编号')}： {item['sn']}</div>
                      <Divider type="vertical" />
                      <div className={styles.t2}>{t('求购时间')}： {item['createdAt']}</div>
                      <div className={styles.fileLink}>
                        {
                          item.attachmentName&&
                          <Button type='text' loading={activeId===item.id&&downloadLoading} onClick={()=>downloadFile(item)}><PaperClipOutlined />{item.attachmentName}</Button>
                        }
                      </div>
                    </div>
                    <Table className={styles.table}
                            pagination={false}
                            // bordered
                            rowClassName={makeRowClassName}
                            dataSource={item.inquiryItems}
                            rowKey='id'
                            columns={columns}/>

                  </div>

                </List.Item>
              )}
            />
            <div className="pagination_container">
                <Pagination
                  showSizeChanger={true}
                  showLessItems={true}
                  current={store.page}
                  pageSize={store.pageSize}
                  total={store.pageTotal}
                  showTotal={total => `共 ${total} 条`}
                  pageSizeOptions={['10', '20', '50', '100']}
                  onChange={(page,size)=>store.pageChange(page,size,activeKey === 'all' ? null : activeKey)}
                />
            </div>
        </div>


      </div>

    </React.Fragment>
  )

})

